import { useCallback } from "react";
import { first } from "lodash";
import { useLazyQuery } from "@apollo/client";
import { pagedSearchTags } from "src/queries/tags.graphql";
import { useTagsHierarchyViewer } from "../context";
import { updateTagChildren } from "../actions/tagsActions";

/**
 * Custom hook for handling node toggle functionality in TagsHierarchyViewer
 * @param {Function} setToggledNodes - State setter for toggled nodes
 * @returns {Function} handleNodeToggled - Function to handle node toggle events
 */
export const useHandleNodeToggle = (setToggledNodes) => {
  const [getChildTags] = useLazyQuery(pagedSearchTags);
  const { dispatch } = useTagsHierarchyViewer();

  const handleNodeToggled = useCallback(
    async (node) => {
      const { id, toggled } = node;

      setToggledNodes((prev) => ({
        ...prev,
        [id]: toggled,
      }));

      if (toggled && node?.id) {
        await getChildTags({
          variables: {
            input: {
              filter: {
                tagIds: [node.id],
              },
            },
            includeChildTags: true,
          },
          onCompleted: (d) => {
            dispatch(
              updateTagChildren(node.id, first(d?.results?.tags)?.childTags)
            );
          },
        });
      }
    },
    [getChildTags, dispatch, setToggledNodes]
  );

  return handleNodeToggled;
};
